import React, { useState, useRef } from 'react';
import { useAuth } from "../context/AuthContext";
import { useConfig } from '../context/ConfigContext';
import '../App.css';

const SketchUpload = (fetchData) => {
    const { user, id } = useAuth();
    const { backendApiBaseUrl } = useConfig();
    const [sketchURL, setSketchURL] = useState();
    const fileInputRef = useRef(null);
    const [image, setImage] = useState(null);
    const [sketcherUserId, setSketcherUserId] = useState('');
    const [sketchDescription, setSketchDescription] = useState('');
    const [inkwell, setInkwell] = useState('');
    const [character, setCharacter] = useState('');
    const [series, setSeries] = useState('');
    const maxChars = 200;
    const isOverLimit = sketchDescription.length > maxChars;
    const [errorMessage, setErrorMessage] = useState("");
    const [cardCode, setCardCode] = useState("");


    const handleDescriptionChange = (e) => {
        const input = e.target.value;
        setSketchDescription(input.slice(0, maxChars));
      };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        // Check for duplicate filenames
        if (file.type !== "image/png") {
            setErrorMessage("Only PNG files are allowed.");
            return;
        }
    
        const updatedImage = file;
        setImage(updatedImage);
    };

    const resetForm = () => {
        setImage(null);
        setSketchDescription("");
        setSketchURL(null);
        setCharacter("")
        setSeries("")
        setCardCode("");
        setInkwell("");
        setSketcherUserId("");
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };


    const uploadImage = async (e) => {
        try {
            e.preventDefault();
            setErrorMessage("");

            if (!image) {
                return;
            }

            const cachedURL = URL.createObjectURL(image);
            setSketchURL(cachedURL);
            
            // for sending formdata with file

            const formData = new FormData();

            formData.append("image", image); // Backend should accept `image` instead of `images`
            formData.append("user", JSON.stringify(user));
            formData.append("userId", id);
            formData.append("cardCode", cardCode);
            formData.append("character", character);
            formData.append("series", series);
            formData.append("sketchDescription", sketchDescription);
            formData.append("inkwell", inkwell);
            formData.append("sketcherUserId", sketcherUserId);
            const storedToken = localStorage.getItem('token');
            const token = JSON.parse(storedToken)?.token;
            const response = await fetch(`${backendApiBaseUrl}/sketches/upload`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                body: formData
            });

            const result = await response.json();

            if (!response.ok) {
                setErrorMessage(result.error || "Upload failed");
                return;
            }

            resetForm();
            fetchData.fetchData();

        } catch (error) {
            console.error("Upload error:", error);
            setErrorMessage("An unexpected error occurred.");
        }
    };

    const isFormValid = () => {
        const hasImage = image !== null;
        const hasCardCode = cardCode.trim().length > 0;
        const hasCharacter = character.trim().length > 0;
        const hasSeries = series.trim().length > 0;
        const hasSketcherId = sketcherUserId.trim().length > 0;
        const hasInkwell = inkwell.trim().length > 0;
        return hasImage && hasCardCode && hasSketcherId && !isOverLimit && hasInkwell && hasCharacter && hasSeries;
    };



    return (
        <div style={{ padding: "10px 5px" }}>
            <p>*Image</p>

            <form>
                <div>
                    {errorMessage && (
                    <div style={{ color: "red", marginBottom: "10px" }}>
                        {errorMessage}
                    </div>
                    )}

                    <div 
                        style={{
                            background: "#313338",
                            padding: "10px",
                            borderRadius: "5px",
                            marginBottom: "20px",
                        }}
                    >
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".png"
                            onChange={handleFileChange}
                            className="form-control"
                        />
                    </div>

                </div>
                
                <div style={{marginBottom: "30px", marginTop: "30px"}}>
                    <label style={{paddingBottom:"15px", }}>*Card Code</label>
                    <input
                        className="form-control"
                        type="text"
                        id="cardCode"
                        name="cardCode"
                        maxLength={7}
                        value={cardCode}
                        onChange={(e) => setCardCode(e.target.value)}
                    >
                    </input>
                </div>

                <div style={{ marginBottom: "30px" }}>
                    <label>*Sketched Character</label>
                    <input
                        className="form-control"
                        type="text"
                        name="character"
                        value={character}
                        onChange={(e) => setCharacter(e.target.value)}
                        required
                    />
                </div>

                <div style={{ marginBottom: "30px" }}>
                    <label>*Series</label>
                    <input
                        className="form-control"
                        type="text"
                        name="series"
                        value={series}
                        onChange={(e) => setSeries(e.target.value)}
                        required
                    />
                </div>

                <div  style={{marginBottom: "30px"}}>
                    <label style={{paddingBottom:"15px", }}>Description</label>
                    <textarea 
                        className="form-control"
                        type="text" 
                        id="sketchDescription" 
                        name="sketchDescription"
                        maxLength={maxChars}
                        placeholder="How much did it cost... What is it good on...."
                        value={sketchDescription} 
                        onChange={handleDescriptionChange}
                    >
                    </textarea>
                    <div style={{textAlign:"right", color:"#FFF",fontSize:"0.8em"}}>
                        {sketchDescription.length}/{maxChars}
                    </div>
                </div>

                <div style={{ marginBottom: "30px" }}>
                    <label>*Sketch Inkwell</label>
                    <input
                        className="form-control"
                        type="text"
                        name="inkwell"
                        placeholder='19,400/23,385 or 19,400'
                        value={inkwell}
                        onChange={(e) => setInkwell(e.target.value)}
                        required
                    />
                </div>

                <div style={{ marginBottom: "30px" }}>
                    <label>*Sketcher User ID</label>
                    <input
                        className="form-control"
                        type="text"
                        name="sketcherUserId"
                        value={sketcherUserId}
                        onChange={(e) => setSketcherUserId(e.target.value)}
                        required
                    />
                </div>


                <button type="submit" className="btn btn-primary mt-2" onClick={uploadImage} disabled={!isFormValid()}>
                    Upload
                </button>
                <div style={{textAlign:"center", color:"#FFF",fontSize:"0.8em"}}>
                    * Inputs are required
                </div>
                
            </form>

            {sketchURL && (
                <div className="mt-4">
                    <h4>Uploaded Image:</h4>
                    <img src={sketchURL} alt="Uploaded Preview" className="img-fluid" />
                </div>
            )}
        </div>
        
    )
}

export default SketchUpload;